/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerMaintenanceTimerRequestDto } from './PartnerMaintenanceTimerRequestDto';
import {
    PartnerMaintenanceTimerRequestDtoFromJSON,
    PartnerMaintenanceTimerRequestDtoFromJSONTyped,
    PartnerMaintenanceTimerRequestDtoToJSON,
    PartnerMaintenanceTimerRequestDtoToJSONTyped,
} from './PartnerMaintenanceTimerRequestDto';
import type { PartnerMaintenancePricingCombinationRequestDto } from './PartnerMaintenancePricingCombinationRequestDto';
import {
    PartnerMaintenancePricingCombinationRequestDtoFromJSON,
    PartnerMaintenancePricingCombinationRequestDtoFromJSONTyped,
    PartnerMaintenancePricingCombinationRequestDtoToJSON,
    PartnerMaintenancePricingCombinationRequestDtoToJSONTyped,
} from './PartnerMaintenancePricingCombinationRequestDto';

/**
 * 
 * @export
 * @interface PartnerMaintenanceLevelRequestDto
 */
export interface PartnerMaintenanceLevelRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceLevelRequestDto
     */
    code: PartnerMaintenanceLevelRequestDtoCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceLevelRequestDto
     */
    penaltyClauseText?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenanceLevelRequestDto
     */
    penaltyAmount?: number | null;
    /**
     * 
     * @type {Array<PartnerMaintenanceTimerRequestDto>}
     * @memberof PartnerMaintenanceLevelRequestDto
     */
    timers: Array<PartnerMaintenanceTimerRequestDto>;
    /**
     * 
     * @type {Array<PartnerMaintenancePricingCombinationRequestDto>}
     * @memberof PartnerMaintenanceLevelRequestDto
     */
    pricingCombinations: Array<PartnerMaintenancePricingCombinationRequestDto>;
}


/**
 * @export
 */
export const PartnerMaintenanceLevelRequestDtoCodeEnum = {
    N1: 'N1',
    N2: 'N2',
    N3: 'N3',
    N4: 'N4',
    N5: 'N5',
    R1: 'R1',
    R2: 'R2',
    R3: 'R3',
    R4: 'R4',
    R5: 'R5'
} as const;
export type PartnerMaintenanceLevelRequestDtoCodeEnum = typeof PartnerMaintenanceLevelRequestDtoCodeEnum[keyof typeof PartnerMaintenanceLevelRequestDtoCodeEnum];


/**
 * Check if a given object implements the PartnerMaintenanceLevelRequestDto interface.
 */
export function instanceOfPartnerMaintenanceLevelRequestDto(value: object): value is PartnerMaintenanceLevelRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('timers' in value) || value['timers'] === undefined) return false;
    if (!('pricingCombinations' in value) || value['pricingCombinations'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceLevelRequestDtoFromJSON(json: any): PartnerMaintenanceLevelRequestDto {
    return PartnerMaintenanceLevelRequestDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceLevelRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceLevelRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'penaltyClauseText': json['penaltyClauseText'] == null ? undefined : json['penaltyClauseText'],
        'penaltyAmount': json['penaltyAmount'] == null ? undefined : json['penaltyAmount'],
        'timers': ((json['timers'] as Array<any>).map(PartnerMaintenanceTimerRequestDtoFromJSON)),
        'pricingCombinations': ((json['pricingCombinations'] as Array<any>).map(PartnerMaintenancePricingCombinationRequestDtoFromJSON)),
    };
}

export function PartnerMaintenanceLevelRequestDtoToJSON(json: any): PartnerMaintenanceLevelRequestDto {
    return PartnerMaintenanceLevelRequestDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceLevelRequestDtoToJSONTyped(value?: PartnerMaintenanceLevelRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'penaltyClauseText': value['penaltyClauseText'],
        'penaltyAmount': value['penaltyAmount'],
        'timers': ((value['timers'] as Array<any>).map(PartnerMaintenanceTimerRequestDtoToJSON)),
        'pricingCombinations': ((value['pricingCombinations'] as Array<any>).map(PartnerMaintenancePricingCombinationRequestDtoToJSON)),
    };
}

